const state = {
  currentPage: "Invoices"
}

const actions = {
  pageDidChange ({ commit },pageTitle) {
    commit('pageDidChange',pageTitle)    
  }
}

const mutations = {
  pageDidChange (state,pageTitle) {
    console.log(pageTitle)
    state.currentPage = pageTitle
  }  
}

export const app = {
  namespaced: true,
  state,
  actions,
  mutations
}
